import { deleteAction, getAction, postAction, putAction } from '@api/manage'
import { MTC_ONLINE } from '@api/servers'

// 模板下载
export const templateDown = (tableName, excludeColumns) => {
  return `${window._CONFIG.domianURL}/${MTC_ONLINE}cgform/api/downloadFile/${tableName}?excludeColumns=${excludeColumns}`
}
// 设备管理列表
export const efcOcnDeviceList = params => getAction(`${MTC_ONLINE}efcOcnDeviceManagement/list`, params)
// 编辑保存
export const efcOcnDeviceEdit = params => putAction(`${MTC_ONLINE}efcOcnDeviceManagement/update`, params)
// 设备变更记录列表
export const efcOcnDeviceChangeList = params => getAction(`${MTC_ONLINE}efcOcnDeviceChangeRecord/list`, params)
// 设备详情基本信息
export const efcOcnDeviceQueryById = params => getAction(`${MTC_ONLINE}efcOcnDeviceManagement/queryById`, params)
// 设备新增保存
export const efcOcnDeviceAdd = params => postAction(`${MTC_ONLINE}efcOcnDeviceManagement/save`, params)
// 设备移除
export const efcOcnDeviceRemove = params => postAction(`${MTC_ONLINE}efcOcnDeviceManagement/remove`, params)
// 设备更换
export const efcOcnDeviceChange = params => postAction(`${MTC_ONLINE}efcOcnDeviceManagement/change`, params)
// 设备停用
export const efcOcnDeviceStop = params => postAction(`${MTC_ONLINE}efcOcnDeviceManagement/stop`, params)
// 设备启用
export const efcOcnDeviceRecovery = params => postAction(`${MTC_ONLINE}efcOcnDeviceManagement/recovery`, params)
// 设备撤回
export const efcOcnDeviceCancel = params => postAction(`${MTC_ONLINE}efcOcnDeviceManagement/cancel`, params)
// 设备导入
export const efcOcnDeviceUpload = `${window._CONFIG.domianURL}/${MTC_ONLINE}efcOcnDeviceManagement/uploadExcel`

// 医疗档案详情
export const medicalRecordQueryById = params => getAction(`${MTC_ONLINE}efcOcnMedicalMedicalRecord/queryById`, params)
// 医疗-处方管理-分页列表查询
export const medicalRecordList = params => getAction(`${MTC_ONLINE}efcOcnMedicalPrescription/list`, params)

// 增强JS列表
export const enhanceJSList = params => getAction(`${MTC_ONLINE}cgform/sysEnjsCommonConfig/list`, params)
// 获取所有JS增强公用方法列表
export const enhanceJSListAll = params => getAction(`${MTC_ONLINE}cgform/sysEnjsCommonConfig/listAll`, params)
// 增强JS添加
export const enhanceJSAdd = params => postAction(`${MTC_ONLINE}cgform/sysEnjsCommonConfig/add`, params)
// 增强JS编辑
export const enhanceJSEdit = params => putAction(`${MTC_ONLINE}cgform/sysEnjsCommonConfig/edit`, params)
// 增强JS删除
export const enhanceJSDelete = params => deleteAction(`${MTC_ONLINE}cgform/sysEnjsCommonConfig/delete`, params)
// 在线表单标准详情接口
export const cgformDetail = ({ code, id }) => getAction(`${MTC_ONLINE}cgform/api/form/${code}/${id}`)

// 报表动物下拉框接口
export const efcOcnMdAnimalList = params => getAction(`${MTC_ONLINE}efcOcnMdAnimal/list`, params)
// 报表指标下拉框接口
export const efcOcnStandardMedicalOtherList = params => getAction(`${MTC_ONLINE}standard/efcOcnStandardMedicalOther/list`, params)
// 指标数据查询
export const reportList = params => getAction(`${MTC_ONLINE}medicalRecord/efcOcnMedicalBlood/reportList`, params)